import React,{Component} from 'react';
import "./header/Header.css" ;
import "../scss/general.css";
import Moment from "moment";
import logo from "./images/loading.gif";
import ModalError from "./ModalError";
import Cookies from 'universal-cookie';
const cookies=new Cookies();

const axios = require("axios");
class Notification extends Component{
  constructor(props)
  {
    super(props);
    this.state=
    { myitems:[],
      input:{},
      isLoaded: false,
      ErrMsg:<img src={logo} alt="Error"/>,
      date: Moment(new Date()).format("DD/MM/YYYY")
    };
  }
  componentDidMount()
  {
      document.body.style.cursor="wait";
      axios({
          method: 'post',
          url: cookies.get("phpclass")+'/index.php/user/GetNews/',
//          data: this.state.input,
          headers: {'Content-Type': 'multipart/form-data'}
      })
      .then((response)=> {
          document.body.style.cursor="default";
          this.setState({
              ErrMsg:"",
              isLoaded: true,
              myitems: response.data
          });
      })
      .catch=()=> {
        document.body.style.cursor="default";
        this.setState({ErrMsg:<ModalError/>});
      };      

    }  
    render()
    {
      let isLoaded = this.state.isLoaded;
      let items = this.state.myitems;
      if(isLoaded){
      return(
        <div className="container1">
            <br></br>
          <div width="100%" scroll="hidden"  align= "center" >
          <span className="box-title">HR policies and documents</span>

          <div className="inner-div" >
           <table >
                {items.map((result, i)=>{
                  
                  let fileExtension = result.filepath.split('.').pop()+".png?ver"+Math.random();
                  let filename=config.Appdir+"/doc/"+result.filepath;
                    return(
                      <tr key={i} >
                        <td width="80%" align="left" padding="2px"><h5>{result.Title}</h5>
                        {result.Description}
                        <hr style={{height:"3px",borderwidth:"0",color:"gray",backgroundcolor:"gray"}}></hr>

                        </td>
                        <td width="20%" align="center" padding="1px" >
                            {/*<a href={filename} download target="_blank">*/}
                            <a href={filename} download >
                                <img src={"images/News/"+fileExtension} alt="" width="40" height="40"/><br></br>
                                 
                            </a>

                        </td> 
                    </tr>
                        )})}
  
                    </table>
                    </div>
                    </div>
              </div>
      )
    }
    else
    {
      return(
        <div className="container1">
            <div className="center">
          {this.state.ErrMsg}
        </div>
        </div>
        )
    }
    }
}
export default Notification;